function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Arrow Left Line Large Oblique"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-width": 32,
  "data-height": 19,
  "data-default-max-height": 19,
  className: "iconic-container",
  transform: " translate(0 6)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  className: "iconic-arrow-stem iconic-property-stroke",
  d: "M0 9.5h29",
  fill: "none",
  transform: " rotate(180 16 16 ) translate(0 13)"
}), /*#__PURE__*/React.createElement("path", {
  className: "iconic-arrow-head iconic-arrow-head-line-large-oblique iconic-property-fill",
  d: "M32 9.5l-7-9.5h-3.5l7 9.5-7 9.5h3.5z",
  display: "inline",
  transform: " rotate(180 16 16 ) translate(0 13)"
}));

function SvgArrowLeftLineLargeObliqueMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-icon": "arrow-left-line-large-oblique",
    width: 32,
    height: 32,
    className: "iconic iconic-arrow iconic-size-md iconic-arrow-left-line-large-oblique",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLineLargeObliqueMd);
export default __webpack_public_path__ + "static/media/arrow-left-line-large-oblique-md.5faa9eda.svg";
export { ForwardRef as ReactComponent };